<template>
  <section>
    <h6>Jobs</h6>
  </section>
</template>

<script>
export default {
  name: 'Jobs'
}
</script>

<style></style>
